import { formatDateStr } from '../../utils/DateUtil';

export default function BlogCardSummary({
    postCount, accessCount, collectedAt, domainRegisteredAt, latestPublishedAt,
    publishedAtHighlight, accessCountHighlight, createTimeHighlight,
}) {
    const latestPublishedAtFormatted = formatDateStr(latestPublishedAt);
    const collectedAtFormatted = formatDateStr(collectedAt);
    const domainRegisteredAtFormatted = formatDateStr(domainRegisteredAt, true);

    const highlightStyle = { color: '#C15F3C' };

    return (
        <div className="redesign-blog-stats">
            <div>
                <div className="redesign-blog-stat-label">文章收录</div>
                <div className="redesign-blog-stat-value">{postCount}</div>
            </div>
            <div>
                <div className="redesign-blog-stat-label">文章浏览</div>
                <div className="redesign-blog-stat-value" style={accessCountHighlight ? highlightStyle : undefined}>{accessCount}</div>
            </div>
            <div>
                <div className="redesign-blog-stat-label">最近更新</div>
                <div className="redesign-blog-stat-value">{latestPublishedAtFormatted}</div>
            </div>
            <div>
                <div className="redesign-blog-stat-label">{createTimeHighlight ? '建博时间' : '收录时间'}</div>
                <div className="redesign-blog-stat-value" style={publishedAtHighlight || createTimeHighlight ? highlightStyle : undefined}>
                    {createTimeHighlight ? domainRegisteredAtFormatted : collectedAtFormatted}
                </div>
            </div>
        </div>
    );
}
